export const domain = 'ProductFilter';

// action types
export const FETCH_ERROR = `${domain}/FETCH_ERROR`;
export const IS_FETCHING = `${domain}/IS_FETCHING`;
export const RECEIVE_FILTERABLE_OPTIONS = `${domain}/RECEIVE_FILTERABLE_OPTIONS`;
export const RECEIVE_FILTERS = `${domain}/RECEIVE_FILTERS`;
export const RECEIVE_SPEC_ATTRIBUTES = `${domain}/RECEIVE_SPEC_ATTRIBUTES`;
export const RESET_FILTERS = `${domain}/RESET_FILTERS`;
export const SET_MAX_PRICE_TEXT = `${domain}/SET_MAX_PRICE_TEXT`;
export const SET_MIN_PRICE_TEXT = `${domain}/SET_MIN_PRICE_TEXT`;
